import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Label,
  Input,
  Button,
} from "reactstrap";

import api from "../../../utils/api";
import { toast } from "react-toastify";

const CreateClientModal = ({
  isOpen,
  toggle,
  onSuccess,
}) => {
  const initialState = {
    propertyName: "",
    propertyType: "",
    contactPerson: "",
    mobile: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    adminName: "",
    adminEmail: "",
    password: "",
    plan: "TRIAL",

billingCycle: "TRIAL",
  };

  const [form, setForm] =
    useState(initialState);

  const [loading, setLoading] =
    useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]:
        e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    console.log("================================");
    console.log("🚀 CREATE TENANT STARTED");
    console.log("Payload:", form);

    setLoading(true);

    const startTime = Date.now();

    console.log(
  "🚀 CREATE CLIENT PAYLOAD"
);

console.log(form);

    const res = await api.post(
      "superadmin/create-tenant",
      form
    );

    console.log(
      "✅ RESPONSE RECEIVED",
      res.data
    );

    console.log(
      "⏱ Time Taken:",
      Date.now() - startTime,
      "ms"
    );

    toast.success(res.data.message);

    if (onSuccess) {
  onSuccess();
}

    toggle();

  } catch (err) {
    console.error(
      "❌ CREATE TENANT ERROR"
    );

    console.error(err);

    console.error(
      "Response:",
      err.response?.data
    );

    toast.error(
      err.response?.data?.error ||
      err.response?.data?.message ||
      "Failed to create tenant"
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
    >
      <ModalHeader toggle={toggle}>
        Create Client
      </ModalHeader>

      <ModalBody>
        <Row className="g-3">

          <Col md={6}>
            <Label>
              Property Name
            </Label>

            <Input
              name="propertyName"
              value={
                form.propertyName
              }
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={6}>
            <Label>
              Property Type
            </Label>

            <Input
              type="select"
              name="propertyType"
              value={
                form.propertyType
              }
              onChange={
                handleChange
              }
            >
              <option value="">
                Select
              </option>

              <option>
                Hotel
              </option>

              <option>
                Resort
              </option>

              <option>
                Villa
              </option>

              <option>
                Homestay
              </option>

              <option>
                Apartment
              </option>

            </Input>
          </Col>

          <Col md={6}>
            <Label>
              Contact Person
            </Label>

            <Input
              name="contactPerson"
              value={
                form.contactPerson
              }
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={6}>
            <Label>
              Mobile
            </Label>

            <Input
              name="mobile"
              value={form.mobile}
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={6}>
            <Label>Email</Label>

            <Input
              type="email"
              name="email"
              value={form.email}
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={6}>
            <Label>
              Address
            </Label>

            <Input
              name="address"
              value={
                form.address
              }
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={4}>
            <Label>City</Label>

            <Input
              name="city"
              value={form.city}
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={4}>
            <Label>State</Label>

            <Input
              name="state"
              value={form.state}
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={4}>
            <Label>
              Country
            </Label>

            <Input
              name="country"
              value={
                form.country
              }
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={4}>
            <Label>
              Admin Name
            </Label>

            <Input
              name="adminName"
              value={
                form.adminName
              }
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={6}>
            <Label>
              Admin Email
            </Label>

            <Input
              type="email"
              name="adminEmail"
              value={
                form.adminEmail
              }
              onChange={
                handleChange
              }
            />
          </Col>

          <Col md={6}>
            <Label>
              Password
            </Label>

            <Input
              type="password"
              name="password"
              value={
                form.password
              }
              onChange={
                handleChange
              }
            />
          </Col>

<Col md={6}>
  <Label>Subscription Plan</Label>

  <Input
    type="select"
    name="plan"
    value={form.plan}
    onChange={(e) => {

      const selectedPlan = e.target.value;

      setForm((prev) => ({
        ...prev,
        plan: selectedPlan,

        billingCycle:
          selectedPlan === "TRIAL"
            ? "TRIAL"
            : prev.billingCycle === "TRIAL"
            ? "MONTHLY"
            : prev.billingCycle,
      }));

    }}
  >

    <option value="TRIAL">
      Trial
    </option>

    <option value="STANDARD">
      Standard
    </option>

    <option value="PROFESSIONAL">
      Professional
    </option>

    <option value="ENTERPRISE">
      Enterprise
    </option>

  </Input>

</Col>

{form.plan !== "TRIAL" && (
  <Col md={6}>
    <Label>Billing Cycle</Label>

    <Input
      type="select"
      name="billingCycle"
      value={form.billingCycle}
      onChange={handleChange}
    >
      <option value="MONTHLY">
        Monthly
      </option>

      <option value="YEARLY">
        Yearly
      </option>
    </Input>
  </Col>
)}

        </Row>
      </ModalBody>

      <ModalFooter>
        <Button
          color="secondary"
          onClick={toggle}
        >
          Cancel
        </Button>

        <Button
          color="primary"
          onClick={
            handleSubmit
          }
          disabled={loading}
        >
          {loading
            ? "Creating..."
            : "Create Client"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CreateClientModal;